import React from 'react';

import { StyledDivider } from './styles';

export const Divider = ({ sx = {}, isVertical = false }): JSX.Element => {
  return <StyledDivider sx={sx} isVertical={isVertical} />;
};
